module.exports = "/static/media/CosmicRing.baa38c36.wav";